<template>
  <header class="app-header" :class="{ isMobile: isMobile }">
    <v-overlay style="z-index: 1" :value="drawer && isMobile"></v-overlay>
    <LibHeaderAccessibilityPopup />
    <div class="bar-top content-padd-x" v-if="!isMobile">
      <div class="bar-content">
        <div class="bar-left">
          <LibBtnSimple
            text="Portal eBudownictwo"
            icon="mdi-arrow-left-thin"
            color="#fff"
            href="https://e-budownictwo.gunb.gov.pl/"
            underline
          />
          <LibHeaderSelectNav class="ml-4" />
        </div>
        <div class="bar-right">
          <LibBtnSimple
            text="Ustawienia dostępności"
            icon="mdi-human"
            color="#fff"
            underline
            @click.native="openA11y"
          />
        </div>
      </div>
    </div>

    <div class="banner-test content-padd" v-if="showBannerIsTest">
      <v-icon class="mr-1" color="#333399" size="20">
        mdi-alert-outline
      </v-icon>
      <div class="bold mr-1">
        System w wersji testowej
      </div>
      <div v-if="!isMobile">
        (nie wprowadzaj prawdziwych danych)
      </div>
    </div>

    <div class="bar-main content-padd-x">
      <div class="bar-content">
        <div class="logo-cont">
          <router-link to="/">
            <img class="logo" alt="Logo EDB" src="/img/logo-ckob.svg" />
          </router-link>
        </div>
        <nav class="nav">
          <LibBtnMenu text="Strona główna" class="ml-2" v-if="!isMobile" />
          <LibBtnMenu
            v-if="!isMobile"
            text="Dowiedz się więcej"
            to="dowiedz-sie-wiecej"
            class="ml-8 ml-lg-16"
          />
          <div v-if="!isMobile">
            <v-btn
              v-if="!isLogin"
              depressed
              color="primaryBlue"
              rounded
              large
              dark
              title="Kliknij, aby zalogować się do Elektronicznego Dziennika Budowy"
              class="ml-16"
              @click="login"
            >
              Zaloguj się
            </v-btn>
            <v-btn
              v-else
              depressed
              color="primaryBlue"
              rounded
              large
              dark
              title="Kliknij, aby przejść do aplikacji"
              class="ml-16"
              to="/konto/dane-uzytkownika"
            >
              Przejdź do aplikacji
            </v-btn>
          </div>
          <v-app-bar-nav-icon
            @click.stop="drawer = !drawer"
            color="primaryBlue"
            v-if="isMobile"
            class="btn-drawer"
          ></v-app-bar-nav-icon>
          <v-navigation-drawer
            v-model="drawer"
            v-if="isMobile"
            app
            temporary
            right
            hide-overlay
          >
            <v-list dense nav>
              <v-list-item-group color="primaryBlue">
                <v-list-item to="/" link>
                  <v-list-item-title>Strona główna</v-list-item-title>
                </v-list-item>

                <v-list-item to="dowiedz-sie-wiecej" link>
                  <v-list-item-title>Dowiedz się więcej</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <v-divider></v-divider>
            <v-list dense nav>
              <v-list-item flat>
                <v-list-item-icon class="mr-4">
                  <v-icon>mdi-human</v-icon>
                </v-list-item-icon>
                <v-list-item-title @click="openA11y">
                  Ustawienia dostępności
                </v-list-item-title>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list nav dense>
              <v-list-item-group color="primaryBlue">
                <!-- active-class="deep-purple--text text--accent-4" -->
                <v-list-item v-if="!isLogin">
                  <v-list-item-icon class="mr-4">
                    <v-icon>mdi-login</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title @click="login">
                    Zaloguj się
                  </v-list-item-title>
                </v-list-item>

                <v-list-item v-else to="/konto/dane-uzytkownika">
                  <v-list-item-icon class="mr-4">
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    Przejdź do aplikacji
                  </v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <v-divider></v-divider>
            <v-list nav dense>
              <v-list-item v-if="isLogin" @click.native="logout">
                <v-list-item-icon class="mr-4">
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Wyloguj się</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-navigation-drawer>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import LibBtnSimple from "../common/LibBtnSimple.vue";
import LibHeaderSelectNav from "./LibHeaderSelectNav.vue";
import LibBtnMenu from "../common/LibBtnMenu.vue";
import LibHeaderAccessibilityPopup from "./LibHeaderAccessibilityPopup.vue";
export default {
  name: "LibHeader",
  components: {
    LibBtnSimple,
    LibHeaderSelectNav,
    LibBtnMenu,
    LibHeaderAccessibilityPopup
  },

  props: {},
  data() {
    return {
      drawer: false,
      group: null
    };
  },
  computed: {
    showBannerIsTest() {
      return process.env.VUE_APP_BANNER_IS_TEST === "true";
    }
  },
  methods: {
    login() {
      const props = this.$router.resolve({
        name: "Account"
      });
      let path = window.location.origin.split(/[?#]/)[0];
      if (path.endsWith("/")) path = path.slice(0, -1);
      this.$store.dispatch("auth/login", { redirectUri: path + props.href });
    },
    openA11y() {
      this.$store.commit("layout/setStateA11y", true);
    },
    openWcagDialog() {
      this.isOpenPopupWcag = true;
      this.drawer = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.app-header {
  z-index: 3;
}
.bar-top {
  position: relative;
  background: var(--c-primary);
  color: #fff;
  height: 48px;
  .bar-left,
  .bar-right {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
  }
  .bar-left {
    position: relative;
    left: -21px;
  }
  .bar-right {
    position: relative;
    right: -12px;
  }
  .bar-content {
    max-width: var(--site-width);
    // max-width: calc(var(--site-width) + 42px);
    // padding-right: 8px;
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.bar-main {
  height: 120px;
  // padding: 0 var(--site-padding);
  background: #fff;

  .logo-cont {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .logo {
    width: 150px;
    display: block;
  }
  .bar-content {
    max-width: var(--site-width);
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .nav {
    display: flex;
    align-items: center;
  }
}

.isMobile {
  &.app-header {
    position: sticky;
    top: 0;
  }
  .btn-drawer {
    right: -8px;
  }
  .bar-main {
    height: 64px;
    // box-shadow: 0px 0px 27px 3px rgba(51, 51, 153, 0.1);
    box-shadow: 0px 0px 27px 3px rgba(0, 102, 255, 0.15);
    .logo {
      width: 90px;
    }
  }
}

.banner-test {
  background-color: var(--c-yellow);
  color: var(--c-primary);
  text-align: center;
  padding: 5px 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
